import React from 'react';
import { ConferenceRingingUser } from '../../ConferenceHooks';
import { useTypedSelector } from '../../../../redux/hooks';
import { selectAuthUserByUuid, selectCallerDisplayNameGeneric } from '../../../../redux/slices';
import TypingLoader from '../../../loading/TypingLoader/TypingLoader';

interface Props {
    data: ConferenceRingingUser;
}

const ConferenceRingingMemberUser: React.FC<{ uuid: string }> = ({ uuid }) => {
    const user = useTypedSelector(state => selectAuthUserByUuid(state, uuid));

    return <p>{user?.nickname || 'User'}</p>;
};

const ConferenceRingingMemberNumber: React.FC<{ callee: string }> = ({ callee }) => {
    const { name } = useTypedSelector(state => selectCallerDisplayNameGeneric(state, callee));

    return <p>{name || callee}</p>;
};

const ConferenceRingingMember: React.FC<Props> = ({ data }) => (
    <li>
        <p>
            <TypingLoader mini white />
            {data.type === 'user' ? (
                <ConferenceRingingMemberUser uuid={data.ref} />
            ) : (
                <ConferenceRingingMemberNumber callee={data.ref} />
            )}
        </p>
    </li>
);

export default ConferenceRingingMember;
